import { useId, useRef } from 'react';
import { useDialogFocus } from './useDialogFocus.js';

// Leaving with unsaved changes (boards NavShell and NavPhone, other states):
// asked once for every way out of the shell. Focus starts on the safe
// answer; Esc and the scrim keep the page and its edits. Styles live with
// the shell (ApplicationShell.css, .leave-dialog).
export default function LeaveDialog({ title = 'Leave this page?', body = '', onStay, onLeave }) {
  const containerRef = useRef(null);
  const stayRef = useRef(null);
  const headingId = useId();
  const bodyId = useId();
  useDialogFocus({ open:true, onClose:onStay, containerRef, initialFocusRef:stayRef });
  return <div className="leave-dialog__scrim" onMouseDown={event => { if (event.target === event.currentTarget) onStay?.(); }}>
    <section ref={containerRef} className="leave-dialog" role="dialog" aria-modal="true" aria-labelledby={headingId} aria-describedby={bodyId} tabIndex={-1}>
      <h2 id={headingId} className="leave-dialog__title">{title}</h2>
      <p id={bodyId} className="leave-dialog__body">{body}</p>
      <div className="leave-dialog__actions">
        <button type="button" className="leave-dialog__leave" onClick={onLeave}>Discard and leave</button>
        <button ref={stayRef} type="button" className="leave-dialog__stay" onClick={onStay}>Stay on this page</button>
      </div>
    </section>
  </div>;
}
